import React from 'react'
import PropTypes from "prop-types";
import ChartSection from './ChartSection';

function ProgressChartSection({ title, description, component, children, ...props }) {
  return (
    <ChartSection
      title={title}
      description={description}
      component={component}
      {...props}
    >
      {children}
    </ChartSection>
  )
}

ProgressChartSection.propTypes = {
  title: PropTypes.shape({}),
  description: PropTypes.shape({}),
  component: PropTypes.node,
  children: PropTypes.node
};

ProgressChartSection.defaultProps = {
  title: undefined,
  description: undefined,
  component: undefined,
  children: undefined
}


export default ProgressChartSection;